import { useEffect, useState } from "react";
import "../assets/css/NMIStyles.css";
import { Col, Row } from "reactstrap";
import { SEND_SINGLE_NMI_B_TRANSACTION } from "../graphql/mutations/nmi_b";
import { useMutation } from "@apollo/client";

export default function NMI_B() {
  const [zip, setZip] = useState("");
  const [error, setError] = useState("");
  const [requestingToken, setRequestingToken] = useState(false);

  // const [loading, setLoading] = useState(false);
  const [theCardToken, setCardToken] = useState();

  const [sendSingleNMI_B_Transaction] = useMutation(
    SEND_SINGLE_NMI_B_TRANSACTION,
  );

  const [valid, setValid] = useState({
    ccnumber: false,
    ccexp: false,
    cvv: false,
  });

  useEffect(() => {
    const initCollect = () => {
      if (!window.CollectJS || window.__collectConfigured) return;

      window.__collectConfigured = true;

      let validFields = {
        ccnumber: false,
        ccexp: false,
        cvv: false,
      };

      window.CollectJS.configure({
        variant: "inline",

        fields: {
          ccnumber: { selector: "#cc-number" },
          ccexp: { selector: "#cc-exp" },
          cvv: { selector: "#cc-cvv" },
        },

        validationCallback: function (field, status, message) {
          validFields[field] = status;

          window.dispatchEvent(
            new CustomEvent("nmi-validation", {
              detail: {
                field,
                status,
                message,
                allValid:
                  validFields.ccnumber && validFields.ccexp && validFields.cvv,
              },
            }),
          );
        },

        callback: function (response) {
          window.dispatchEvent(
            new CustomEvent("nmi-token", {
              detail: response,
            }),
          );
        },
      });

      console.log("CollectJS configured ✅");
    };

    if (window.CollectJS) {
      initCollect();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://secure.nmi.com/token/Collect.js";
    script.async = true;
    script.dataset.tokenizationKey = process.env.REACT_APP_NMI_B_PUBLIC_KEY;

    script.onload = initCollect;

    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const tokenHandler = (e) => {
      if (!requestingToken) {
        console.log("Ignored auto token");
        return;
      }

      // setLoading(true);

      const expMonth = e.detail.card.exp.slice(0, 2).padStart(2, "0");
      const expYear = e.detail.card.exp.slice(2, 4);
      const lastFour = e.detail.card.number.slice(-4);

      setCardToken({
        id: e.detail.token,
        card: {
          exp_month: expMonth,
          exp_year: expYear,
          last4: lastFour,
          bin: e.detail.card.bin,
        },
      });

      setTimeout(() => {
        SendIFrameMessage(null, "SendBillingData");
      }, 1000);

      console.log("Bin:", e.detail.card.bin);
      console.log("Exp:", e.detail.card.exp);
      console.log("Number:", e.detail.card.number);
      console.log("Token:", e.detail.token);

      setRequestingToken(false);
      setError("");
    };

    window.addEventListener("nmi-token", tokenHandler);

    // setLoading(false);
    return () => window.removeEventListener("nmi-token", tokenHandler);
  }, [requestingToken]);

  useEffect(() => {
    const validationHandler = (e) => {
      const { field, status } = e.detail;

      setValid((prev) => ({
        ...prev,
        [field]: status,
      }));
    };

    window.addEventListener("nmi-validation", validationHandler);
    return () =>
      window.removeEventListener("nmi-validation", validationHandler);
  }, []);

  const handlePayClick = () => {
    let errors = [];

    if (!zip) {
      errors.push("ZIP Code is required");
    } else if (!/^\d{5}(-\d{4})?$/.test(zip)) {
      errors.push("ZIP Code is invalid");
    }

    if (!valid.ccnumber) errors.push("Card Number is invalid");
    if (!valid.ccexp) errors.push("Expiration Date is invalid");
    if (!valid.cvv) errors.push("CVC is invalid");

    if (errors.length > 0) {
      setError(errors[0]);
      return;
    }

    if (!window.CollectJS) {
      setError("Payment system not ready");
      return;
    }

    setRequestingToken(true);
    window.CollectJS.startPaymentRequest();
  };

  //WC STUFF
  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage(
      { type: "FROM_IFRAME", payload: { data: data, action: action } },
      process.env.REACT_APP_WOWCLOUD_PARENT +
        "/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111",
    ); //Parent
  };

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent

      const { type, payload } = event.data;
      if (type === "FROM_PARENT") {
        if (payload.action === "SendBillingData") {
          const serverPayload = {
            token: theCardToken.id,
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(payload.data.zip),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(theCardToken.card.exp_month),
              expYear: parseInt(theCardToken.card.exp_year),
              lastFour: parseInt(theCardToken.card.last4),
              processorTransactionId: theCardToken.id,
              bin: theCardToken.card.bin,
              paymentid: payload.data.paymentid,
              productid: payload.data.productid,
              refid: payload.data.refid,
              shortdescription: payload.data.shortdescription,
              existingcustomer: payload.data.existingcustomer,
              referral: payload.data.referral,
            },
          };

          console.log("ServerPayload", serverPayload);
          SendSingleTransaction(serverPayload);
        } else if (payload.action == "Reset") {
          // setLoading(false);
        }
      }
    };

    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, [theCardToken]);

  const SendSingleTransaction = (serverPayload) => {
    sendSingleNMI_B_Transaction({
      variables: {
        token: serverPayload.token,
        paymentdata: serverPayload.paymentdata,
      },
    })
      .then((tres) => {
        if (tres.data.sendSingleNMI_B_Transaction.status) {
          SendIFrameMessage(
            tres.data.sendSingleNMI_B_Transaction.data,
            "TransactionSuccess",
          );
          // setLoading(false);
        } else {
          if (
            tres.data.sendSingleNMI_B_Transaction.error ===
            "CardValidationRequired"
          ) {
            SendIFrameMessage(
              tres.data.sendSingleNMI_B_Transaction.error,
              "CardValidationRequired",
            );
            // setLoading(false);
          } else {
            SendIFrameMessage(
              tres.data.sendSingleNMI_B_Transaction.error,
              "TransactionError",
            );
            // setLoading(false);
          }
        }
      })
      .catch((err) => {
        // console.log("ERROR2", err)
      })
      .finally(() => {
        handleReset();
        //TODO: Set loading
      });
  };

  const handleReset = () => {
    if (!window.CollectJS) return;

    try {
      window.CollectJS.clearInputs();
      setZip("");
    } catch (e) {
      console.log("Reset failed:", e);
    }
  };

  return (
    <div className="mwContainer">
      {/* {loading && (
        <Row>
          <Col md="12">
            <h1>Processing ...</h1>
          </Col>
        </Row>
      )}

      {!loading && ( */}
      <div className="container">
        <form className="NMIForm">
          <label>Card Number</label>
          <div id="cc-number" className="NMIElement" style={{ width: "95%" }} />

          <div className="second-line">
            <div className="third-width">
              <label>Exp Date</label>
              <div id="cc-exp" className="NMIElement"></div>
            </div>

            <div className="third-width">
              <label>CVC</label>
              <div id="cc-cvv" className="NMIElement"></div>
            </div>

            <div className="third-width">
              <label>Zip Code</label>
              <input
                type="text"
                className="NMIElement zip-input"
                value={zip}
                onChange={(e) => setZip(e.target.value)}
                placeholder="12345"
              />
            </div>
          </div>

          {error && <div className="error">{error}</div>}

          <button id="payButton" type="button" onClick={handlePayClick}>
            Pay
          </button>
        </form>
      </div>
      {/* )} */}
    </div>
  );
}
